import {
    confirm,
    revokeConfirmation
} from "./actions";

import ItemView from "../../components/ItemView/ItemView.vue"

export default [{
    "path": "/Confirmation",
    "component": { ...ItemView },
    "name": "Confirmation",
    "meta": {
        "app": "ftc",
        "name": "Confirmation",
        title() {
            return `Application Confirmation`;
        },
        "sideNav": true,
        "sideNavSection": "Confirmation",
        "hideBackButton": true,
        "menuActions": [{
            "label": "Confirm",
            "action": confirm
        }, {
            "label": "Revoke Confirmation",
            "action": revokeConfirmation
        }],
        "dataFields": [{
            "label": "Terms and Conditions",
            "class": "md:col-span-3",
            "grow": true,
            compute({ item }) {
                return `<p>By accessing and using this system, you agree to the following terms and conditions regarding the processing of your data:</p>
                        <br/>
                        <ol>
                            <li>All data provided by the user shall be processed in accordance with applicable data protection laws and regulations.</li>
                            <li>The user consents to the collection, storage, and processing of their data for the purpose of providing the services offered by the system.</li>
                            <li>The user has the right to request access to, rectification, or erasure of their personal data held by the system.</li>
                            <li>The system will take appropriate measures to ensure the security and confidentiality of the user's data.</li>
                            <li>The user's data may be transferred to third parties only with their explicit consent or as required by law.</li>
                            <li>The user agrees to indemnify the system against any claims arising from the processing of their data.</li>
                        </ol>
                        <br/>
                    `
            }
        }, {
            "label": "Full Name",
            "key": "raw.User.FullName",
            "type": "text"
        }, {
            "label": "Confirmation Date",
            "key": "raw.Date.Confirmation",
            "type": "date"
        }],
        warning(user) {
            console.log(user);
            return [!user?.Completed, "Please confirm your application to proceed."]
        }
    },
}];
